import { useEffect, useState } from "react";
import ExhibitorCategoryTable from "./ExhibitorCategoryTable";
import ExhibitorCategoryModal from "./ExhibitorCategoryModal";
import ExhibitorCategoryForm from "./ExhibitorCategoryForm";
import Modal from "components/common/Modal";
import Alert from "components/common/Alert";
import { useExhibitorCategory } from "./hooks/useExhibitorCategory";
import { useOrganizers } from "components/company/hooks/useOrganizers";

export default function ExhibitorCategoryContainer() {
  const {
    data,
    loading,
    loadCategories,
    addCategory,
    editCategory,
    removeCategory,
    loadCategoryById,
    loadCategoryByOrganizer
  } = useExhibitorCategory();

  const [editing, setEditing] = useState(null);
  const [openAdd, setOpenAdd] = useState(false);
  const [alert, setAlert] = useState({ type: "", message: "" });

  const [selectedOrganizer, setSelectedOrganizer] = useState(
    localStorage.getItem("company_id") || ""
  );

  // const userId = localStorage.getItem("user_id") || "unknown";

  const userId = "69579c6190a653b640e65639";


  useEffect(() => {
    if (selectedOrganizer) {
      loadCategoryByOrganizer(selectedOrganizer);
    }
  }, [selectedOrganizer]);

  useEffect(() => {
    const handleOrganizerChange = (e) => {
      setSelectedOrganizer(e.detail);
    };

    window.addEventListener("companyChanged", handleOrganizerChange);
    return () =>
      window.removeEventListener("companyChanged", handleOrganizerChange);
  }, []);

  return (
    <>
      <div className="mb-4 flex justify-end">
        <button
          className="rounded bg-blue-600 px-4 py-2 text-white"
          onClick={() => setOpenAdd(true)}
        >
          + Add Exhibitor Category
        </button>
      </div>

      {alert.message && (
        <Alert
          type={alert.type}
          message={alert.message}
          autoClose
          onClose={() => setAlert({ type: "", message: "" })}
        />
      )}

      <ExhibitorCategoryTable
        data={data}
        loading={loading}
        onEdit={async (row) => {
          const category = await loadCategoryById(row._id);
          setEditing(category);
        }}
        onDelete={async (id) => {
          if (window.confirm("Are you sure you want to delete this category?")) {
            try {
              const res = await removeCategory(id, {
                is_deleted: true,
                deleted_by: userId,
              });

              setAlert({
                type: "success",
                message: res.message || "Category deleted successfully",
              });

              loadCategoryByOrganizer(selectedOrganizer);
            } catch (error) {
              setAlert({
                type: "error",
                message:
                  error.response?.data?.message ||
                  "Unable to delete category",
              });
            }
          }
        }}
      />

      <Modal open={openAdd} onClose={() => setOpenAdd(false)}>
        <ExhibitorCategoryModal
          onClose={() => setOpenAdd(false)}
          onSubmit={async (payload, setModalError) => {
            try {
              payload.append("created_by", userId);

              await addCategory(payload);

              setOpenAdd(false);
              loadCategoryByOrganizer(selectedOrganizer);
            } catch (error) {
              setModalError(
                error.response?.data?.message ||
                "Something went wrong while creating exhibitor category"
              );
            }
          }}
        />
      </Modal>

      <Modal open={!!editing} onClose={() => setEditing(null)}>
        <ExhibitorCategoryModal
          initialData={editing}
          onClose={() => setEditing(null)}
          onSubmit={async (payload, setModalError) => {
            try {
              payload.append("updated_by", userId);

              await editCategory(editing._id, payload);

              setEditing(null);
              loadCategoryByOrganizer(selectedOrganizer);
            } catch (error) {
              setModalError(
                error.response?.data?.message ||
                "Something went wrong while updating exhibitor category"
              );
            }
          }}
        />
      </Modal>

    </>
  );
}